<script>
    import { createEventDispatcher } from 'svelte';
    import Fa from 'svelte-fa'
    import { faEdit } from '@fortawesome/free-solid-svg-icons'
    
    const dispatch = createEventDispatcher();

    export let item;

    function clickExecuted() {
        dispatch('clicked', {
            item
        });
    }
</script>

<div class="IconEdit" on:click={clickExecuted}>
    <Fa icon={faEdit} />
</div>

<style>
    .IconEdit {
        padding-right: 10px;
        cursor: pointer;
        color: green;
    }
</style>